import { runInAction } from 'mobx';
import { getItemById } from '../../../sales-data/selectors/items/get-item-by-id';
import { getItemModifierGroupById } from '../../../sales-data/selectors/items/get-item-modifier-group-by-id';
import { assertIsNormalItem } from '../../../sales-data/utils/items/item-type-utils';
import { createDefaultInProgressNormalItem } from './create-default-in-progress-normal-item';
import { updateInProgressItemIsValid } from './update-in-progress-item-is-valid';
import { updateInProgressItemTotalPrice } from './update-in-progress-item-total-price';
import { updateInProgressItemTotalSavings } from './update-in-progress-item-total-savings';
export const updateParentSalesItemOption = (inProgressItem, optionItemId, quantity, selectedPrice) => {
    const selectedOption = inProgressItem.item.options.find(option => option.itemId === optionItemId);
    const selectedOptionItem = selectedOption && getItemById(selectedOption.itemId);
    assertIsNormalItem(selectedOptionItem, `Cannot update option item with ID: ${optionItemId} for parent sales item with ID: (${inProgressItem.item.id}`);
    const hasRequiredModifiers = selectedOptionItem.modifierGroups.find(group => {
        const modifierGroup = getItemModifierGroupById(group.itemModifierGroupId);
        return modifierGroup && modifierGroup.quantityLimit.minimum > 0;
    });
    if (hasRequiredModifiers) {
        throw new Error(`${selectedOptionItem.id} can't be updated. Required modifiers are not allowed when setting a parent sales item with multiple options.`);
    }
    const item = createDefaultInProgressNormalItem(selectedOptionItem, selectedPrice);
    runInAction(() => {
        inProgressItem.selectedInProgressItems[optionItemId] = { item, quantity, optionItemId };
    });
    updateInProgressItemIsValid(inProgressItem);
    updateInProgressItemTotalSavings(inProgressItem);
    updateInProgressItemTotalPrice(inProgressItem);
};
